import { createSelector } from '@reduxjs/toolkit';
import lodashFind from 'lodash/find';

const filter = (state) => state.filter;

const categoryFilterSelector = createSelector(
  filter,
  (state) => state.home.category,
);
const distanceFilterSelector = createSelector(filter, (state) =>
  lodashFind(state.home.tags, { paramName: 'distance' }),
);
const parentCategorySelector = createSelector(
  filter,
  (state) => state.parentCategory,
);
const tagsFilterSelector = createSelector(filter, (state) => state.home.tags);
const whenFilterSelector = createSelector(filter, (state) => state.home.when);
const selectReservationFilter = createSelector(
  filter,
  (state) => state.listings,
);
const selectReservationStoreFilter = createSelector(
  filter,
  (state) => state.reservationStore,
);
const selectSearchFilter = createSelector(filter, (state) => state.search);

export {
  categoryFilterSelector,
  distanceFilterSelector,
  parentCategorySelector,
  tagsFilterSelector,
  whenFilterSelector,
  selectReservationFilter,
  selectReservationStoreFilter,
  selectSearchFilter,
};
